export default {"src":"/_next/static/media/0xce7de646e7208a4ef112cb6ed5038fa6cc6b12e3.deed8de2.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};